<template>
    <v-layout wrap>
        <v-flex class="mb-4 d-flex align-items-center">
            <div>
                <h1 class="d-inline-block vertical-align-middle">{{ $t('user-tasks') }}</h1>
            </div>
        </v-flex>
        <v-flex xs12>
            <v-card class="pa-2 pt-3 mb-3">
                <v-form @submit.prevent="getUserTasks">
                    <v-layout wrap>
                        <v-flex md4 sm6 xs12 px-2 v-if=" 1===0 && $store.getters.user.source !== 4">
                            <v-autocomplete :label="$t('user-name')"
                                            v-model="filter.userId"
                                            :items="usersList"
                                            name="userId"
                                            :item-text="'fullName'"
                                            item-value="id"
                                            clearable></v-autocomplete>
                        </v-flex>
                        <v-flex md3 sm6 xs12 px-2>
                            <v-autocomplete :label="$t('process-ActionBar')"
                                            v-model="filter.processId"
                                            :items="processesList"
                                            name="processId"
                                            :item-text="getLabelByLang('processName', 'processName')"
                                            item-value="processId"
                                            clearable></v-autocomplete>
                        </v-flex>
                        <v-flex md2 px-2 sm6 xs12>
                            <v-menu :close-on-content-click="false"
                                    :nudge-right="40"
                                    full-width
                                    lazy
                                    min-width="290px"
                                    offset-y
                                    ref="menu"
                                    transition="scale-transition"
                                    v-model="fromDateMenu">
                                <v-text-field :data-vv-as="$t('from-date')"
                                              :label="$t('from-date')"
                                              clearable
                                              name="fromDate"
                                              prepend-icon="event"
                                              readonly
                                              slot="activator"
                                              v-model="filter.fromDate"></v-text-field>
                                <v-date-picker :max="filter.toDate ? filter.toDate : ''"
                                               @change="fromDateMenu = false"
                                               min="1900-01-01"
                                               ref="picker"
                                               v-model="filter.fromDate"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex md2 px-2 sm6 xs12>
                            <v-menu :close-on-content-click="false"
                                    :nudge-right="40"
                                    full-width
                                    lazy
                                    min-width="290px"
                                    offset-y
                                    ref="menu"
                                    transition="scale-transition"
                                    v-model="toDateMenu">
                                <v-text-field :data-vv-as="$t('to-date')"
                                              :label="$t('to-date')"
                                              clearable
                                              name="toDate"
                                              prepend-icon="event"
                                              readonly
                                              slot="activator"
                                              v-model="filter.toDate"></v-text-field>
                                <v-date-picker :min="filter.fromDate ? filter.fromDate : '1900-01-01'"
                                               @change="toDateMenu = false"
                                               ref="picker"
                                               v-model="filter.toDate"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex md4 px-2 sm6 xs12>
                            <v-text-field :data-vv-as="$t('beneficiary-nationalNumJOR')"
                                          :label="$t('guestusername')"
                                          class="mr-2"
                                          name="beneficiaryNationalNumJOR"
                                          v-model="filter.beneficiaryNationalNumJOR"></v-text-field>
                        </v-flex>
                        <v-flex md4 px-2 sm6 xs12>
                            <v-text-field :data-vv-as="$t('full-name')"
                                          :label="$t('full-name')"
                                          class="mr-2"
                                          name="fullName"
                                          v-model="filter.fullName"></v-text-field>
                        </v-flex>
                        <v-flex md3 px-2 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('disability-type')"
                                            :error-messages="errors.collect('typeOfDisability')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="disabilityNaturesList"
                                            :label="$t('disability-type')"
                                            clearable
                                            item-value="code"
                                            name="typeOfDisability"
                                            v-model="filter.typeOfDisability"></v-autocomplete>
                        </v-flex>

                        <v-flex md3 px-2 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('region')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="regionList"
                                            :label="$t('region')"
                                            clearable
                                            item-value="code"
                                            name="region"
                                            v-model="filter.region"></v-autocomplete>
                        </v-flex>

                        <v-flex md3 px-2 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('governorate')"
                                            :disabled="isDisabled"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="governoratesList"
                                            :label="$t('governorate')"
                                            clearable
                                            item-value="code"
                                            name="governorate"
                                            v-model="filter.governorate"></v-autocomplete>
                        </v-flex>

                        <v-flex xs12>
                            <v-btn color="primary" type="submit">{{ $t('filter') }}</v-btn>
                            <v-btn color="primary" type="reset" @click="filterInit()">{{ $t('reset') }}</v-btn>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-card>
        </v-flex>
        <v-flex xs12>
            <v-data-table :loading="isLoading" hide-actions :headers="headers" :items="userTasks" class="elevation-1">
                <template slot="items" slot-scope="props">
                    <td>{{ props.item.processName }}</td>
                    <td>{{ props.item.activityName }}</td>
                    <td>{{ props.item.createdat | date }}</td>
                    <td>{{ props.item.fullName }}</td>
                    <td>{{ props.item.beneficiaryNationalNumJOR   }}</td>
                    <td>
                        <v-btn icon @click="goToTask(props.index)">
                            <v-icon>mdi-playlist-edit</v-icon>
                        </v-btn>
                    </td>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>
    import SecurityProcessService from "@/services/AdminSystem/Security/SecurityProcessService";
    import ProcessTaskService from '@/services/WorkFlow/ProcessTaskService';
    import UserService from '@/services/UserService';
    import LookUpService from '@/services/LookUpService';

    export default {
        name: 'user-tasks',
        data: () => ({
            isLoading: false,
            userTasks: [],
            processesList: [],
            usersList: [],
            disabilityNaturesList: [],
            selectedDisabilityType: [],
            governoratesList: [],
            regionList: [],
            filter: {},
            fromDateMenu: false,
            toDateMenu: false
        }),
        async created() {
            this.filterInit();
            this.$store.dispatch('showLoading');
            await this.GetSecurityProcessByUserId();
            await this.getUsers();
            this.$store.dispatch('hideLoading');
            this.getUserTasks();
            this.getDisabilityNatures();
            this.getGovernorates();
        },
        methods: {
            goToTask(taskIndex) {
                const task = this.userTasks[taskIndex];
                if (!task.url) return;
                if (task.url.toLowerCase().includes('appointment'))
                    if (!task.subApplicationID)
                        this.$router.push({
                            name: 'add-appointments-by-task',
                            params: {
                                from: '1',
                                beneficiaryInformationId: task.applicationID,
                                taskId: task.id,
                                processInstanceId: task.processInstanceId
                            }
                        });
                    else
                        this.$router.push({
                            name: 'edit-appointments-by-task',
                            params: {
                                from: '1',
                                beneficiaryInformationId: task.applicationID,
                                taskId: task.id,
                                processInstanceId: task.processInstanceId,
                                id: task.subApplicationID
                            }
                        });
                else if (task.url.toLowerCase().includes('service-details'))
                    if (!task.subApplicationID)
                        this.$router.push({
                            name: 'add-service-details-by-task',
                            params: {
                                from: '1',
                                id: task.applicationID,
                                taskId: task.id,
                                processInstanceId: task.processInstanceId
                            }
                        });
                    else
                        this.$router.push({
                            name: 'edit-service-details-by-task',
                            params: {
                                from: '1',
                                id: task.applicationID,
                                taskId: task.id,
                                processInstanceId: task.processInstanceId
                            }
                        });
                else if (task.url.toLowerCase().includes('laptop-details'))
                    if (!task.subApplicationID)
                        this.$router.push({
                            name: 'add-laptop-details-by-task',
                            params: {
                                from: '1',
                                id: task.applicationID,
                                taskId: task.id,
                                processInstanceId: task.processInstanceId
                            }
                        });
                    else
                        this.$router.push({
                            name: 'edit-laptop-details-by-task',
                            params: {
                                from: '1',
                                id: task.applicationID,
                                taskId: task.id,
                                processInstanceId: task.processInstanceId
                            }
                        });
                else if (task.url.toLowerCase().includes('speech-therapy'))
                    if (!task.subApplicationID)
                        this.$router.push({
                            name: 'add-SpeechTherapy-details-by-task',
                            params: {
                                from: '1',
                                id: task.applicationID,
                                taskId: task.id,
                                processInstanceId: task.processInstanceId
                            }
                        });
                    else
                        this.$router.push({
                            name: 'edit-SpeechTherapy-details-by-task',
                            params: {
                                from: '1',
                                id: task.applicationID,
                                taskId: task.id,
                                processInstanceId: task.processInstanceId
                            }
                        });
                else if (task.url.toLowerCase().includes('university-details'))
                    if (!task.subApplicationID)
                        this.$router.push({
                            name: 'add-university-details-by-task',
                            params: {
                                from: '1',
                                id: task.applicationID,
                                taskId: task.id,
                                processInstanceId: task.processInstanceId
                            }
                        });
                    else
                        this.$router.push({
                            name: 'edit-university-details-by-task',
                            params: {
                                from: '1',
                                id: task.applicationID,
                                taskId: task.id,
                                processInstanceId: task.processInstanceId
                            }
                        });
                else if (task.url.toLowerCase().includes('diagnos'))
                    if (!task.subApplicationID)
                        this.$router.push({
                            name: 'add-diagnosis-by-task',
                            params: {
                                from: '1',
                                beneficiaryInformationId: task.applicationID,
                                taskId: task.id,
                                processInstanceId: task.processInstanceId
                            }
                        });
                    else
                        this.$router.push({
                            name: 'edit-diagnosis-by-task',
                            params: {
                                from: '1',
                                beneficiaryInformationId: task.applicationID,
                                taskId: task.id,
                                processInstanceId: task.processInstanceId,
                                id: task.subApplicationID
                            }
                        });
                else if (task.url.toLowerCase().includes('operat'))
                    if (!task.subApplicationID)
                        this.$router.push({
                            name: 'add-manage-operating-by-task',
                            params: {
                                from: '1',
                                id: task.applicationID,
                                taskId: task.id,
                                processInstanceId: task.processInstanceId
                            }
                        });
                    else
                        this.$router.push({
                            name: 'edit-manage-operating-by-task',
                            params: {
                                from: '1',
                                id: task.applicationID,
                                taskId: task.id,
                                processInstanceId: task.processInstanceId
                            }
                        });
                else if (task.url.toLowerCase().includes('beneficiary'))
                    if (!task.applicationID)
                        this.$router.push({
                            name: 'add-beneficiary-by-task',
                            params: {
                                from: '1',
                                taskId: task.id,
                                processInstanceId: task.processInstanceId
                            }
                        });
                    else
                        this.$router.push({
                            name: 'edit-beneficiary-by-task',
                            params: {
                                from: '1',
                                taskId: task.id,
                                processInstanceId: task.processInstanceId,
                                id: task.applicationID
                            }
                        });
                else if (task.url.toLowerCase().includes('aid'))
                    if (!task.applicationID)
                        this.$router.push({
                            name: 'add-aid-by-task',
                            params: {
                                from: '1',
                                taskId: task.id,
                                processInstanceId: task.processInstanceId
                            }
                        });
                    else
                        this.$router.push({
                            name: 'edit-aid-by-task',
                            params: {
                                from: '1',
                                taskId: task.id,
                                processInstanceId: task.processInstanceId,
                                id: task.applicationID
                            }
                        });
                else if (task.url.toLowerCase().includes('permenant'))
                    if (!task.applicationID)
                        this.$router.push({
                            name: 'add-requestpermission-by-task',
                            params: {
                                from: '1',
                                taskId: task.id,
                                processInstanceId: task.processInstanceId
                            }
                        });
                    else
                        this.$router.push({
                            name: 'edit-requestpermission-by-task',
                            params: {
                                from: '1',
                                taskId: task.id,
                                processInstanceId: task.processInstanceId,
                                id: task.applicationID
                            }
                        });
                else if (task.url.toLowerCase().includes('application'))
                    this.$router.push({
                        name: 'edit-application-form-by-task',
                        params: {
                            from: '1',
                            taskId: task.id,
                            processInstanceId: task.processInstanceId,
                            id: task.applicationID
                        }
                    });
                else if (task.url.toLowerCase().includes('social'))
                    this.$router.push({
                        name: 'edit-social-case-study-form-by-task',
                        params: {
                            from: '1',
                            taskId: task.id,
                            processInstanceId: task.processInstanceId,
                            id: task.applicationID
                        }
                    });
                else if (task.url.toLowerCase().includes('decision'))
                    this.$router.push({
                        name: 'edit-decision-form-by-task',
                        params: {
                            from: '1',
                            taskId: task.id,
                            processInstanceId: task.processInstanceId,
                            id: task.applicationID
                        }
                    });
                else if (task.url.toLowerCase().includes('followuploan'))
                    this.$router.push({
                        name: 'edit-follow-up-family-loan-by-task',
                        params: {
                            from: '1',
                            taskId: task.id,
                            processInstanceId: task.processInstanceId,
                            id: task.applicationID,
                            followupid: task.subApplicationID,
                        }
                    });
                else if (task.url.toLowerCase().includes('installment'))
                    this.$router.push({
                        name: 'edit-installment-by-task',
                        params: {
                            from: '1',
                            taskId: task.id,
                            processInstanceId: task.processInstanceId,
                            id: task.applicationID
                        }
                    });
                else if (task.url.toLowerCase().includes('creditfund'))
                    this.$router.push({
                        name: 'edit-creditFundDefinition-by-task',
                        params: {
                            from: '1',
                            taskId: task.id,
                            processInstanceId: task.processInstanceId,
                            id: task.applicationID
                        }
                    });
                else if (task.url.toLowerCase().includes('productionprojectrequestassevaluation'))
                    this.$router.push({
                        name: 'edit-associationAppEvaluation-by-task',
                        params: {
                            from: '1',
                            taskId: task.id,
                            processInstanceId: task.processInstanceId,
                            applicationId: task.applicationID
                        }
                    });
                else if (task.url.toLowerCase().includes('followproductprojreq'))
                    this.$router.push({
                        name: 'edit-followProductionProjSixMonth-by-task',
                        params: {
                            from: '1',
                            taskId: task.id,
                            processInstanceId: task.processInstanceId,
                            applicationId: task.applicationID
                        }
                    });
                else if (task.url.toLowerCase().includes('productionprojectrequest'))
                    this.$router.push({
                        name: 'edit-productionProjectRequest-by-task',
                        params: {
                            from: '1',
                            taskId: task.id,
                            processInstanceId: task.processInstanceId,
                            applicationId: task.applicationID
                        }
                    });
                else if (task.url.toLowerCase().includes('tickting'))
                    this.$router.push({
                        name: 'edit-tickting-by-task',
                        params: {
                            from: '1',
                            taskId: task.id,
                            processInstanceId: task.processInstanceId,
                            applicationId: task.applicationID
                        }
                    });
                else if (task.url.toLowerCase().includes('cfundloan')) {
                    this.$router.push({
                        name: 'edit-projectStudyFormInfo-by-task',
                        params: {
                            from: '1',
                            taskId: task.id,
                            processInstanceId: task.processInstanceId,
                            applicationId: task.applicationID
                        }
                    });
                }
            },
            async getUserTasks() {
                this.isLoading = true;
                const result = await ProcessTaskService.getProcessTaskByCriteria(this.filter);
                if (result.data) this.userTasks = result.data;
                this.isLoading = false;
            },
            filterInit() {
                const year1 = (new Date().getFullYear()).toString();
                let month1 = ((new Date().getMonth()) + 1).toString();
                if (month1 < 10) {
                    month1 = '0' + month1;
                }
                this.filter = {
                    keyword: '',
                    processId: 0,
                    userId: this.$store.getters.user.id,
                    status: 0,
                    fromDate: year1 + '-' + month1 + '-01',
                    toDate: '',
                    typeOfDisability: '',
                    fullName: '',
                    beneficiaryNationalNumJOR: '',
                    governorate: '',
                    region: '',
                };
                this.getUserTasks();
            },
            async getGovernorates() {
                this.governoratesList = (await LookUpService.getLookup(62)).data;
                this.regionList = (await LookUpService.getLookup(215)).data;
            },
            async getDisabilityNatures() {
                this.disabilityNaturesList = (await LookUpService.getLookup(112)).data;
            },
            /* Get all SecurityProcess info */
            async GetSecurityProcessByUserId() {
                const body = {
                    roleID: 0,
                    processId: 0
                };

                this.processesList = (await SecurityProcessService.GetSecurityProcessByUserId(body)).data;
            },
            async getUsers() {
                this.usersList = (await UserService.getUsers()).data;
            }
        },
        computed: {
            headers() {
                return [
                    { text: this.$t('process-ActionBar'), value: 'process-ActionBar', sortable: false },
                    { text: this.$t('current-activity'), value: 'activityName', sortable: false },
                    { text: this.$t('task-date'), value: 'hPInstance-taskdate', sortable: false },
                    { text: this.$t('full-name'), value: 'fullName', sortable: false },
                    { text: this.$t('beneficiary-nationalNumJOR'), value: 'beneficiaryNationalNumJOR', sortable: false },
                    { text: this.$t('actionsDetails'), value: '', sortable: false }
                ];
            }
        }
    };
</script>
<style>
</style>